import { PriceType, type PriceTypeType } from '@/api/hooks/useTenantConfig'
import { BBDTag } from '@gravitate-js/excalibrr'
import { Select } from 'antd'
import _ from 'lodash'

interface PriceTypesSelectProps {
  value: PriceTypeType[]
  onChange: (value: PriceTypeType[]) => void
  autoFocus?: boolean
  defaultOpen?: boolean
  width?: number
  height?: number
}

const options = Object.values(PriceType).map((priceType) => ({
  value: priceType,
  label: _.startCase(priceType),
}))

const MIN_WIDTH = 200
const MAX_WIDTH = 320

export function PriceTypesSelect({
  value,
  onChange,
  autoFocus = false,
  defaultOpen = false,
  width,
  height,
}: PriceTypesSelectProps) {
  const controlWidth = Math.min(
    Math.max(width ?? MIN_WIDTH, MIN_WIDTH),
    MAX_WIDTH,
  )

  return (
    <div style={{ display: 'flex', alignItems: 'center', height: '100%' }}>
      <Select
        mode='multiple'
        value={value}
        onChange={onChange}
        placeholder='Select price types'
        allowClear
        autoFocus={autoFocus}
        defaultOpen={defaultOpen}
        style={{ width: controlWidth, height }}
        tagRender={(tagProps) => (
          <BBDTag
            theme2
            style={{ margin: '2px' }}
            closable={tagProps.closable}
            onClose={tagProps.onClose}
          >
            {tagProps.label}
          </BBDTag>
        )}
        optionRender={(option) => (
          <BBDTag theme2 style={{ margin: 0 }}>
            {option.data.label}
          </BBDTag>
        )}
        options={options}
        virtual={false}
        placement='bottomLeft'
        popupMatchSelectWidth
        getPopupContainer={() => document.body}
      />
    </div>
  )
}
